module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0wIDIuMTE1TDIuMTE1IDBMMTAuNSA4LjM4NUwxOC44ODUgMEwyMSAyLjExNUwxMi42MTUgMTAuNUwyMSAxOC44ODVMMTguODg1IDIxTDEwLjUgMTIuNjE1TDIuMTE1IDIxTDAgMTguODg1TDguMzg1IDEwLjVMMCAyLjExNVoiIGZpbGw9IiNjY2NjY2MiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homebase/modal_icon_close.svg
// module id = /vfa
// module chunks = 1